import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { settingsAPI } from '../utils/api';

const AnalyticsScripts = () => {
  const [analytics, setAnalytics] = useState({
    yandex_metrika: '',
    google_analytics: ''
  });

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const response = await settingsAPI.get();
        setAnalytics({
          yandex_metrika: response.data.yandex_metrika || '',
          google_analytics: response.data.google_analytics || ''
        });
      } catch (error) {
        console.error('Error fetching analytics settings:', error);
      }
    };

    fetchAnalytics();
  }, []);

  return (
    <Helmet>
      {/* Яндекс.Метрика */}
      {analytics.yandex_metrika && (
        <>
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `
                (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                ym(${analytics.yandex_metrika}, "init", {
                  clickmap:true,
                  trackLinks:true,
                  accurateTrackBounce:true,
                  webvisor:true
                });
              `
            }}
          />
          <noscript>{`<div><img src="https://mc.yandex.ru/watch/${analytics.yandex_metrika}" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
        </>
      )}

      {/* Google Analytics */}
      {analytics.google_analytics && (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${analytics.google_analytics}`} />
          <script
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${analytics.google_analytics}');
              `
            }}
          />
        </>
      )}
    </Helmet>
  );
};

export default AnalyticsScripts;
